import React from "react";
import { useTranslation } from "react-i18next";

import { SurveyForm, SurveyList } from "./";
import { ManagementLayout } from "@components/shared";
import { Card, Title } from "@mantine/core";

import { survey as dummySurvey } from "@dummy/survey";

export default function SurveyManagement() {
  const { t } = useTranslation();
  return (
    <ManagementLayout
      dataComponent={<SurveyList items={[dummySurvey]} />}
      createComponent={
        <Card>
          <Title order={4}>
            {t("create")} {t("cs:survey_singular")}
          </Title>
          <SurveyForm onSuccess={() => {}} />
        </Card>
      }
    />
  );
}
